import { WsSelect } from 'wisestep-base';

import { WsAccordion } from '../../../../components/filters/components';

import TechFetchFilterProps from './TechFetchFilterProps';

const SelectFilters = ({
  name,
  title = 'Job Type',
  selectArray = [],
  startIcon,
}: TechFetchFilterProps) => (
  <WsAccordion title={title} {...(startIcon && { startIcon: startIcon })}>
    <WsSelect name={name} selectArray={selectArray} placeholder="Select" />
  </WsAccordion>
);
export default SelectFilters;
